import React from 'react'
import { Button, Stack } from '@mui/material'
import { formatSki } from 'src/Libs/flow/advanced-settings/utils/format-ski'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import useModals from 'src/Hooks/useModals'

interface TrustSKIPanelProps {
  smgSki?: string
  isSmgwSkiTrusted: boolean
  emcDeviceId?: string
  trustSmartMeterGatewaySki: ({ storageId, skiToTrust }: { storageId: string | undefined; skiToTrust: string }) => Promise<void | null>
  isDisabled?: boolean
}

const TrustSKIPanel: React.FC<TrustSKIPanelProps> = ({ smgSki, isSmgwSkiTrusted, emcDeviceId, trustSmartMeterGatewaySki, isDisabled }) => {
  const { t } = useCustomTranslation()
  const { enqueueErrorStack, enqueueSuccessStack } = useSnackbar()
  const { openConfirmationModal } = useModals()

  const handleDeleteTrustedSki = (): void => {
    //todo: delete trusted ski
  }

  const handleTrustSki = (skiToTrust: string): void => {
    openConfirmationModal({
      title: t('installation-configuration.em360.smg-trust-confirmation.title'),
      text: t('installation-configuration.em360.smg-trust-confirmation.description'),
      onConfirm: onClose => {
        trustSmartMeterGatewaySki({ storageId: emcDeviceId, skiToTrust })
          .then(() => enqueueSuccessStack(t('installation-configuration.em360.smg-controlbox.trust-ski-success')))
          .catch(() => enqueueErrorStack(t('installation-configuration.em360.smg-controlbox.trust-ski-error')))
          .finally(() => onClose())
      },
      buttonText: [t('common.cancel'), t('common.confirm')],
    })
  }

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'} alignItems={{ xs: 'flex-start', sm: 'center' }} gap={2}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent={'space-between'}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        flex={1}
        gap={2}
      >
        <Typography variant={'body1'}>{'installation-configuration.em360.smg-controlbox.smg-ski'}</Typography>
        <Typography variant={'body2'}>{smgSki ? formatSki(smgSki) : '-'}</Typography>
      </Stack>
      {smgSki && (
        <SkiButtons
          isSmgwSkiTrusted={isSmgwSkiTrusted}
          handleDeleteTrustedSki={handleDeleteTrustedSki}
          handleTrustSki={() => handleTrustSki(smgSki)}
          isDisabled={isDisabled}
        />
      )}
    </Stack>
  )
}

export default TrustSKIPanel

interface SkiButtonProps {
  isSmgwSkiTrusted: boolean
  handleDeleteTrustedSki: () => void
  handleTrustSki: () => void
  isDisabled?: boolean
}

const SkiButtons: React.FC<SkiButtonProps & { isDisabled?: boolean }> = ({
  isSmgwSkiTrusted,
  handleDeleteTrustedSki,
  handleTrustSki,
  isDisabled,
}) => {
  const { t } = useCustomTranslation()

  return (
    <>
      {isSmgwSkiTrusted ? null : (
        // todo: add this button for isSmgwSkiTrusted = true once SW1 offers this functionality
        // <Button variant={'contained'} onClick={handleDeleteTrustedSki} sx={{ width: { xs: '100%', sm: 'auto' } }} disabled={isDisabled}>
        //   {t('installation-configuration.em360.smg-controlbox.delete-trusted-ski')}
        // </Button>
        <Button variant={'contained'} onClick={handleTrustSki} sx={{ width: { xs: '100%', sm: 'auto' } }} disabled={isDisabled}>
          {t('installation-configuration.em360.smg-controlbox.trust')}
        </Button>
      )}
    </>
  )
}
